<x-shop-dialog
  (closeDialog)="cancelPayment()"
  i18n-closeTooltip="@@Tooltip.CancelPayment"
  closeTooltip="Cancel Payment"
  i18n-heading="@@Note.Registration.DialogHeading"
  heading="Please enter your payment details"
>
  <div class="payment-form">
    <iframe
      *ngIf="data.iframeUrl"
      id="peachCardFrame"
      name="peachCardFrame"
      [src]="data.iframeUrl"
    ></iframe>
  </div>
</x-shop-dialog>
